export enum OperationStates {
  Failure = "FAILURE",
  Success = "SUCCESS",
  InProgress = "IN_PROGRESS",
  Error = "ERROR",
}
